exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact-us[data-v-4e3562c9] {\n  min-width: 500px;\n}\n.contact-us__title[data-v-4e3562c9], .contact-us__text[data-v-4e3562c9] {\n    margin-bottom: 14px;\n    color: #2C3030;\n}\n.contact-us .form__element[data-v-4e3562c9] {\n    position: relative;\n    margin-bottom: 20px;\n}\n.contact-us .form__element[data-v-4e3562c9]:last-child {\n      margin: 10px 0 0;\n}\n.contact-us .form__send-error[data-v-4e3562c9], .contact-us .form__error[data-v-4e3562c9] {\n    font-size: 12px;\n    color: #B11D1D;\n}\n.contact-us .form__error[data-v-4e3562c9] {\n    position: absolute;\n    bottom: -20px;\n    left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e3562c9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/navigation/contact-us_popup/contact-us.vue
// module id = dbGf
// module chunks = 1